const RegEx = {
  email: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/,
  mobile: /^(?:\+91|0|\+1|\+81)?[6-9]\d{9}$/,
  businessName: /^[A-Za-z0-9&',.() -]+$/,
  roleName: /^[A-Za-z0-9 ]+$/,
  GST: /^(0[1-9]|1[0-9]|2[0-9]|3[0-8]|99|97)[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Za-z]$/,
  PAN: /^[A-Z]{5}[0-9]{4}[A-Z]$/,
  pinCode: /^[a-zA-Z0-9 -]*$/,
  onlyNumber: /^[0-9]+$/,
  names: /^[A-Za-z]+$/,
  fullName: /^[A-Za-z ]+$/,
  replaceNumber: /[^+\d]/g,
  website: /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/,
  CIN: /^[UL][0-9]{5}[A-Za-z]{2}[0-9]{4}[A-Za-z]{3}[0-9]{6}$/,
  SSN: /^\d{9}$/,
  EIN: /^\d{9}$/,
  IN: /^\d{12}$/,
  CN: /^\d{13}$/,
  NINO: /^[A-CEGHJ-PR-TW-Z]{2}\d{6}[A-D]{1}$/,
  CRN: /^[A-Z]{2}\d{6}$|^\d{8}$/,
  VAT: /^\d{9}(\d{3})?$/,
  mainName: /[a-zA-Z]+\s*/,
  nonDecimal: /^[1-9]\d*$/,
  percentage: /^(?!0\.00\.000)\d{1,2}(?:\.\d{1,2})?$|^100(?:\.00?)?$/,
  twoDigitDecimal: /^[0-9]\d*(\.\d{1,2})?$/,
  twoDigitDecimalMoreThanZero: /^[1-9]\d*(\.\d{1,2})?$/,
  threeDigitDecimalMoreThanZero: /^(0|[1-9]\d*)(\.\d{1,3})?$/,
  noZeroNoNegative: /^[1-9]\d*$/,
  telephone: /^(?:(?:\+91|0)?([1-9]\d{9})|([1-9]\d{9}))$/,
  zeroNoNegative: /^[0-9]\d*$/,
  sumValue: /(\d)(?=(\d\d)+\d$)/g,
  parser: /\$\s?|(,*)/g,
  breakCamelCase: /([a-z])([A-Z])/g,
  removeSlash: /\//g,
  transformInput: / {2}/g,
  selectedYear: /\b(202[2-3])\b/g
};

export default RegEx;
